/**
 * sophior-lp-verkoop.js
 * Hoort bij sections/sophior-lp-verkoop.liquid: het actieblok op datum en de
 * sticky knop.
 */

/*
 * Actieblok (early access, Black Friday of kerst): de server kiest het blok,
 * maar Shopify cachet pagina's kort. Kies daarom bij het laden opnieuw op de
 * klok: zichtbaar is het blok waarvoor data-lp-van <= nu < data-lp-tot (in
 * seconden). Bij een voorbeeld in de thema-editor ontbreekt data-lp-acties en
 * blijft de keuze van de server staan.
 */
(function () {
  var houder = document.querySelector('[data-lp-acties]');
  if (!houder) return;

  var nu = Date.now() / 1000;
  houder.querySelectorAll('[data-lp-van]').forEach(function (blok) {
    var van = Number(blok.getAttribute('data-lp-van'));
    var tot = Number(blok.getAttribute('data-lp-tot'));
    blok.hidden = !(nu >= van && nu < tot);
  });
})();

/*
 * Sticky knop, alleen mobiel (de CSS verbergt hem vanaf 750px).
 *
 * Zichtbaar zodra de heroknop boven uit beeld is en zolang het aanbod nog niet
 * in beeld is geweest of verderop ligt; weg zodra het aanbod in beeld komt of
 * voorbij is. Nooit samen met de cookiebanner van Shopify. Verborgen = inert,
 * dus de knop is dan niet focusbaar voor toetsenbord en schermlezer.
 */
(function () {
  var bar = document.querySelector('[data-lp-sticky]');
  if (!bar || !('IntersectionObserver' in window)) return;

  var heroKnop = document.querySelector('[data-lp-hero-knop]');
  var aanbod = document.getElementById(bar.getAttribute('data-lp-aanbod'));
  if (!heroKnop || !aanbod) return;

  var heroVoorbij = false;
  var aanbodBereikt = false;

  // De banner staat position: fixed, dus offsetParent is altijd null: kijk naar
  // de afmeting en de berekende stijl.
  function bannerOpen() {
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner) return false;
    var stijl = window.getComputedStyle(banner);
    return banner.getBoundingClientRect().height > 0 && stijl.display !== 'none' && stijl.visibility !== 'hidden';
  }

  function update() {
    var tonen = heroVoorbij && !aanbodBereikt && !bannerOpen();
    bar.classList.toggle('is-zichtbaar', tonen);
    bar.setAttribute('aria-hidden', tonen ? 'false' : 'true');
    if (tonen) {
      bar.removeAttribute('inert');
    } else {
      bar.setAttribute('inert', '');
    }
  }

  new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      heroVoorbij = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    });
    update();
  }).observe(heroKnop);

  new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      aanbodBereikt = entry.isIntersecting || entry.boundingClientRect.top < 0;
    });
    update();
  }).observe(aanbod);

  // De cookiebanner sluit na een klik; daarna opnieuw beoordelen.
  document.addEventListener('click', function () {
    window.setTimeout(update, 400);
  });
})();
